import { render, staticRenderFns } from "./ViewOrderSummery.vue?vue&type=template&id=24aa3c08&scoped=true"
import script from "./ViewOrderSummery.vue?vue&type=script&lang=js"
export * from "./ViewOrderSummery.vue?vue&type=script&lang=js"
import style0 from "./ViewOrderSummery.vue?vue&type=style&index=0&id=24aa3c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa3c08",
  null
  
)

export default component.exports